export default __webpack_public_path__ + "static/media/HBTC-WHT.7764fdd5.svg";